import { typographyResponsive } from "../../styles/utils/typography.module";
export const MuiBadgeTheme = (dt) => {
    return {
        defaultProps: {
            max: 999,
        },
        styleOverrides: {
            badge: Object.assign(Object.assign({}, typographyResponsive(dt, "caption")), { minWidth: dt.size.medium, height: dt.size.medium, borderRadius: dt.borderRadius.pill, "&.Pxl-border": {
                    border: `${dt.brand.borderWidth.small} solid ${dt.color.surface.key}`,
                } }),
            standard: {
                color: dt.color.onSurface.key,
                backgroundColor: dt.color.surface.key,
                "&.Pxl-border": {
                    border: `${dt.brand.borderWidth.small} solid ${dt.color.onSurface.key}`,
                },
            },
            colorPrimary: {
                color: dt.color.onPrimary.key,
                backgroundColor: dt.color.primary.key,
                "&.Pxl-border": {
                    border: `${dt.brand.borderWidth.small} solid ${dt.color.surface.key}`,
                },
            },
            colorSecondary: {
                color: dt.color.onSecondary.key,
                backgroundColor: dt.color.secondary.key,
                "&.Pxl-border": {
                    border: `${dt.brand.borderWidth.small} solid ${dt.color.surface.key}`,
                },
            },
            colorError: {
                color: dt.color.onSignal.error.key,
                backgroundColor: dt.color.signal.error.key,
                "&.Pxl-border": {
                    border: `${dt.brand.borderWidth.small} solid ${dt.color.surface.key}`,
                },
            },
            colorWarning: {
                color: dt.color.onSignal.warning.key,
                backgroundColor: dt.color.signal.warning.key,
                "&.Pxl-border": {
                    border: `${dt.brand.borderWidth.small} solid ${dt.color.surface.key}`,
                },
            },
            colorSuccess: {
                color: dt.color.onSignal.success.key,
                backgroundColor: dt.color.signal.success.key,
                "&.Pxl-border": {
                    border: `${dt.brand.borderWidth.small} solid ${dt.color.surface.key}`,
                },
            },
            colorInfo: {
                color: dt.color.onSignal.info.key,
                backgroundColor: dt.color.signal.info.key,
                "&.Pxl-border": {
                    border: `${dt.brand.borderWidth.small} solid ${dt.color.surface.key}`,
                },
            },
            dot: {
                "&": {
                    // Prevent incorrect definition error during build
                    boxSizing: "content-box",
                },
                width: dt.size.xSmall2,
                height: dt.size.xSmall2,
                minWidth: "auto",
                minHeight: "auto",
            },
        },
    };
};
